import React from 'react';

const NotSupposedToSeePage = () => {
    return (
        <div style={{ padding: '2rem', textAlign: 'center' }}>
            <h1>You are not supposed to see this page</h1>
        </div>
    );
};

export default NotSupposedToSeePage;
